/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import useAPIHandler from "../hook/use-api-handler";
import { logger } from "./logger";


const useCommonApiCall = () => {
    const { fetchData } = useAPIHandler();
    const [allState, setAllState] = useState([]);
    const fetchAllState = async () => {

        try {
            const response = await fetchData({
                url: '/common/state',
                method: "GET",
            })
            if (response?.status === 'success' && Array.isArray(response?.data)) {
                const mappedData = response?.data?.map((item) => ({
                    id: item?.state_id,
                    name: item?.state_name
                }))
                setAllState(mappedData)

            }
        } catch (error) {
            logger.log(error)
        }
    }
    function getStateName(id) {
        const stateName = allState.find(item => item.id === id);

        return stateName ? stateName?.name : 'N/A'
    }
    useEffect(()=>{
        fetchAllState()
    },[])
    return {
        getStateName,
        fetchAllState
    }
}

export default useCommonApiCall




